jQuery(document).ready(function($) {

    $( ".bloc_equipe" ).each(function() {

        let bloc = this
        let membres = Array.from(bloc.querySelectorAll(".equipe .membre"))

        if (!membres.length) return

        // Un ScrollTrigger par carte : chacune remonte quand elle entre dans la vue,
        // piloté par le scroll (scrub). Le start est décalé selon la colonne pour une
        // cascade gauche → droite au sein de chaque ligne.
        membres.forEach(function(membre) {

            // Colonne = nb de cartes plus à gauche sur la même ligne (même offsetTop)
            let top = Math.round(membre.offsetTop)
            let col = membres.filter(function(m) {
                return Math.round(m.offsetTop) === top && m.offsetLeft < membre.offsetLeft
            }).length

            let offset = col * 4

            gsap.fromTo(membre,
                { opacity: 0, y: 60 },
                {
                    opacity: 1,
                    y: 0,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: membre,
                        start: "top " + (90 - offset) + "%",
                        end: "top " + (60 - offset) + "%",
                        scrub: 1
                    }
                }
            )
        })

    })

});
